import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {withTranslation} from 'react-i18next';

import { Confirm } from 'semantic-ui-react';
import TableInfo from '../../components/TableInfo';
import {
    canCreateByFormSelector,
    canEditRowSelector,
    canExportToExcelSelector,
    canImportFromExcelSelector,
    canPartialExportToExcelSelector,
    canDeleteRowsSelector,
    clearDictionaryInfo,
    columnsSelector,
    exportProgressSelector,
    exportToExcelRequest,
    deleteRowsRequest,
    getListRequest,
    importFromExcelRequest,
    importProgressSelector,
    deleteProgressSelector,
    listSelector,
    progressSelector,
    totalCountSelector,
} from '../../ducks/dictionaryView';
import { downloadProgressSelector } from '../../ducks/documents';
import {DICTIONARY_CARD_LINK, DICTIONARY_NEW_LINK} from '../../router/links';
import {
    actionsCardSelector,
    allIdsSelector,
    clearActions,
    getActionsRequest,
    getAllIdsRequest,
    invokeActionRequest
} from "../../ducks/gridActions";


class List extends Component {
    state = {
        confirmation: {
            open: false
        }
    };

    componentWillUnmount() {
        this.props.clear();
    }

    closeConfirmation = () => {
        this.setState({
            confirmation: {
                open: false,
            }
        });
    };

    showConfirmation = (content, onConfirm, onCancel) => {
        this.setState({
            confirmation: {
                open: true,
                content,
                onConfirm,
                onCancel,
            }
        });
    };

    handleImportFromExcel = (form, callbackSuccess) => {
        const { importFromExcel, match } = this.props;
        const { params = {} } = match;
        const { name = '' } = params;

        const callbackConfirmation = (message) => {
            this.showConfirmation(
                message,
                () => {
                    this.closeConfirmation();

                    importFromExcel({
                        form,
                        name,
                        callbackSuccess,
                        isConfirmed: true
                    });
                },
                this.closeConfirmation
            )
        };

        importFromExcel({
            form,
            name,
            callbackSuccess,
            isConfirmed: false,
            callbackConfirmation
        });
    };

    handleExportToExcel = filter => {
        const { exportFromExcel, match } = this.props;
        const { params = {} } = match;
        const { name = '' } = params;
        exportFromExcel({
            name,
            filter,
        });
    };

    handleDeleteRows = (ids, callbackSuccess) => {
        const { deleteRows, match } = this.props;
        const { params = {} } = match;
        const { name = '' } = params;
        deleteRows({
            name,
            ids,
            callbackSuccess
        })
    };

    mapActions = (item, t, invokeAction, name) => ({
        ...item,
        name: `${t(item.name)}`,
        action: (rows, clearSelectedRows) => {
            this.showConfirmation(
                `${t('grid_actions_confirmation')} "${t(item.name)}" ${
                    rows.length > 1 ? `${t('selected_records_label')} ` + `(${rows.length})` : ''
                    }?`,
                () => {
                    this.closeConfirmation();
                    invokeAction({
                        ids: rows,
                        name,
                        actionName: item.name,
                        callbackSuccess: () => {
                            clearSelectedRows();
                        },
                    });
                },
            );
        },
    });

    getGroupActions = () => {
        const { t, actions, invokeAction, match } = this.props;
        const { params = {} } = match;
        const { name = '' } = params;
        const actionsFromGrid = actions.filter(item => item.allowedFromGrid);

        return actionsFromGrid.map(item => this.mapActions(item, t, invokeAction, name));
    };

    


    render() {
        const {
            match = {},
            columns,
            loadList,
            progress,
            totalCount,
            list,
            isCreateBtn,
            canEditRow,
            isImportBtn,
            isExportBtn,
            isDeleteBtn,
            isCheckboxDisplay,
            importLoader,
            exportLoader,
            deleteLoader,
            clear,
            t,
            getActions,
            invokeAction,
            getAllIds,
            clearActions,
            allIds,
            downloadProgress,
        } = this.props;
        const { params = {} } = match;
        const { name = '' } = params;

        return (
            <>
                <TableInfo
                    key={name}
                    headerRow={columns}
                    name={name}
                    className={
                        columns.length >= 10
                            ? 'container'
                            : 'wider ui container container-margin-top-bottom'
                    }
                    loadList={loadList}
                    loading={progress}
                    totalCount={totalCount}
                    title={name}
                    list={list}
                    clear={clear}
                    storageSortItem={`${name}Sort`}
                    storageFilterItem={`${name}Filters`}
                    isImportBtn={isImportBtn}
                    isExportBtn={isExportBtn}
                    isDeleteBtn={isDeleteBtn}
                    checkboxDisplay={isCheckboxDisplay}
                    importFromExcel={this.handleImportFromExcel}
                    exportToExcel={this.handleExportToExcel}
                    deleteRows={this.handleDeleteRows}
                    importLoader={importLoader}
                    exportLoader={exportLoader}
                    deleteLoader={deleteLoader}
                    newLink={isCreateBtn ? DICTIONARY_NEW_LINK : null}
                    cardLink={DICTIONARY_CARD_LINK}
                    getActions={getActions}
                    getAllIds={getAllIds}
                    invokeAction={invokeAction}
                    clearActions={clearActions}
                    allIds={allIds}
                    groupActions={this.getGroupActions}
                    downloadProgress={downloadProgress}
                    canEditRow={canEditRow}
                />
                <Confirm
                    dimmer="blurring"
                    open={this.state.confirmation.open}
                    onCancel={this.state.confirmation.onCancel || this.closeConfirmation}
                    cancelButton={t('cancelConfirm')}
                    confirmButton={t('Yes')}
                    onConfirm={this.state.confirmation.onConfirm}
                    content={this.state.confirmation.content}
                />
            </>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const { match = {} } = ownProps;
    const { params = {} } = match;
    const { name = '' } = params;

    return {
        columns: columnsSelector(state, name),
        progress: progressSelector(state),
        totalCount: totalCountSelector(state),
        list: listSelector(state),
        isCreateBtn: canCreateByFormSelector(state, name),
        canEditRow: canEditRowSelector(state, name),
        isImportBtn: canImportFromExcelSelector(state, name),
        isDeleteBtn: canDeleteRowsSelector(state, name),
        isCheckboxDisplay: canPartialExportToExcelSelector(state, name),
        isExportBtn: canExportToExcelSelector(state, name),
        importLoader: importProgressSelector(state),
        exportLoader: exportProgressSelector(state),
        deleteLoader: deleteProgressSelector(state),
        allIds: allIdsSelector(state),
        actions: actionsCardSelector(state),
        downloadProgress: downloadProgressSelector(state),
    };
};

const mapDispatchToProps = dispatch => {
    return {
        loadList: params => {
            dispatch(getListRequest(params));
        },
        importFromExcel: params => {
            dispatch(importFromExcelRequest(params));
        },
        exportFromExcel: params => {
            dispatch(exportToExcelRequest(params));
        },
        deleteRows: params => {
          dispatch(deleteRowsRequest(params));  
        },
        clear: () => {
            dispatch(clearDictionaryInfo());
        },
        getActions: params => {
            dispatch(getActionsRequest(params));
        },
        invokeAction: params => {
            dispatch(invokeActionRequest(params));
        },
        getAllIds: params => {
            dispatch(getAllIdsRequest(params));
        },
        clearActions: params => {
            dispatch(clearActions(params));
        },
    };
};

export default withTranslation()(
    withRouter(
        connect(
            mapStateToProps,
            mapDispatchToProps,
        )(List),
    ),
);
